import ThankYouPage from '../forms/ThankYouPage'

const ConcreteLandingThankYou = () => (
    <ThankYouPage returnPath="/landing-concrete" contentCategory="Concrete" landingMode />
)

export default ConcreteLandingThankYou
